module.exports = __webpack_public_path__ + "static/media/empty-state-profile-picture.593635c8.svg";